import React from "react"
import HeroText from "./heroText"

const HeroMobile = () => {
  return (
    <div id="heroMobile" className="row d-md-none">
      <div className="container mb-12 d-flex flex-column allign-content-center justify-content-center">
        <HeroText mobile={true} />
      </div>
    </div>
  )
}

export default HeroMobile
